export default "__VITE_ASSET__BAw9PU68__"